import { render } from "./ImgPreview.vue?vue&type=template&id=d0c7c174&ts=true"
import script from "./ImgPreview.vue?vue&type=script&lang=ts"
export * from "./ImgPreview.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=d0c7c174&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__